import { useState } from 'react';
import DrawdownPanel from '../DrawdownPanel/DrawdownPanel';
import { TopUpDeclined } from '../RequestMoreFundsPanel/TopUpStatusMessages/TopUpDeclined';
import TopUpStatusMessage from '../RequestMoreFundsPanel/TopUpStatusMessages/TopUpStatusMessage';
import { Redirect } from 'react-router-dom';
import { Button } from '@iwoca/orion';
import {
    CreateNewApplicationForm,
    TApplicationStatus
} from '../CreateNewApplicationForm/CreateNewApplicationForm';

export const TopUpForm = ({
    formHeader,
    accountId
}: {
    formHeader?: React.ReactNode;
    accountId: string;
}) => {
    const [applicationStatus, setApplicationStatus] =
        useState<TApplicationStatus>(null);

    switch (applicationStatus) {
        case 'auto_approved':
            return <DrawdownPanel />;
        case 'auto_declined':
            return <TopUpDeclined />;
        case 'requires_documents':
            return <Redirect to="/apply-flexi-loan/?topup=true" />;
        case 'docs_complete':
            return (
                <>
                    <TopUpStatusMessage
                        heading="Thanks for your application"
                        description="We'll aim to get back to you in 24 hours but please bear with us if we take a little longer."
                    />
                    <Button onClick={() => window.location.reload()}>
                        Back to dashboard
                    </Button>
                </>
            );
        case 'unknown':
            return (
                <TopUpStatusMessage
                    heading="Oops, it looks like something went wrong"
                    ctaText="Get in touch"
                />
            );
        default:
            return (
                <>
                    {formHeader}
                    <CreateNewApplicationForm
                        accountId={accountId}
                        setApplicationStatus={setApplicationStatus}
                    />
                </>
            );
    }
};
